module.exports = __webpack_public_path__ + "static/media/image_5.344ea879.svg";